import React from 'react';
import PropTypes from 'prop-types';
import { Colors } from '../../../themes/colors';
import { MAX_PROMOTION_VALUE } from './constants';

const round2 = (n) => Math.round(n * 100) / 100;

const boxStyle = {
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  height: 42,
  boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25) inset',
  backgroundColor: Colors.neutral_50,
  borderRadius: 5,
  padding: '0 8px 0 16px',
  color: Colors.neutral_600,
  fontFamily: 'Nunito',
  fontSize: 16,
};

const fieldStyle = {
  flex: 1,
  minWidth: 0,
  // Neutralize the global `input {}` styling (box-shadow / radius / bg / padding)
  // so the field blends into the surrounding currency box.
  border: 'none',
  outline: 'none',
  boxShadow: 'none',
  borderRadius: 0,
  background: 'transparent',
  padding: 0,
  color: Colors.neutral_600,
  fontFamily: 'Nunito',
  fontSize: 16,
};

const stepperColumn = { display: 'flex', flexDirection: 'column', marginLeft: 8 };

const stepperButton = {
  border: 'none',
  background: 'transparent',
  cursor: 'pointer',
  color: Colors.neutral_600,
  fontSize: 10,
  lineHeight: '11px',
  padding: '0 4px',
};

// Currency field for the promotion Max Value: a "$" prefix, always-visible
// up/down steppers, and a hard cap. Typing is clamped to [0, max] with at most
// two decimals so an admin can't submit a runaway amount.
export const MaxValueInput = ({ value, onChange, max, placeholder }) => {
  const toNumber = () => {
    const parsed = Number(String(value).replace(/[^0-9.]/g, ''));

    return Number.isNaN(parsed) ? 0 : parsed;
  };

  const commit = (next) =>
    onChange(round2(Math.min(Math.max(next, 0), max)).toFixed(2));

  const handleChange = (event) => {
    let raw = event.target.value.replace(/[^0-9.]/g, '');
    const [whole, ...rest] = raw.split('.');
    if (rest.length) raw = `${whole}.${rest.join('').slice(0, 2)}`;
    if (Number(raw) > max) raw = String(max);
    onChange(raw);
  };

  return (
    <div style={boxStyle}>
      <span style={{ marginRight: 4 }}>$</span>
      <input
        type="text"
        inputMode="decimal"
        aria-label="Max value"
        style={fieldStyle}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
      />
      <div style={stepperColumn}>
        <button
          type="button"
          aria-label="Increase max value"
          style={stepperButton}
          onClick={() => commit(toNumber() + 1)}
        >
          ▲
        </button>
        <button
          type="button"
          aria-label="Decrease max value"
          style={stepperButton}
          onClick={() => commit(toNumber() - 1)}
        >
          ▼
        </button>
      </div>
    </div>
  );
};

MaxValueInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  max: PropTypes.number,
  placeholder: PropTypes.string,
};

MaxValueInput.defaultProps = {
  value: '',
  max: MAX_PROMOTION_VALUE,
  placeholder: '0.00',
};
